import { defineComponent as x, computed as t, toRef as r, resolveComponent as c, openBlock as o, createBlock as i, mergeProps as l, withCtx as I, unref as a, createCommentVNode as u, createElementVNode as b, renderSlot as y, createTextVNode as h, toDisplayString as C } from "vue";
import { AdsIcon as f } from "../icon/index.js";
import { _ as B } from "../../chunks/index.99cfd0be.js";
import { u as m } from "../../chunks/useIconProps.ee768c90.js";
import './index.css';const P = { class: "ads-link__content" }, V = /* @__PURE__ */ x({
  name: "AdsLink",
  __name: "index",
  props: {
    href: {},
    to: {},
    nuxt: { type: Boolean },
    external: { type: Boolean },
    variation: { default: "default" },
    appearance: { default: "default" },
    asChild: { type: Boolean },
    as: { default: "a" },
    text: {},
    prependIcon: {},
    appendIcon: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const k = t(() => [
      "ads-link",
      e.variation && `ads-link--${e.variation}`,
      (e.prependIcon || e.appendIcon) && "ads-link--icon",
      e.disabled && "ads-link--disabled",
      e.appearance && e.appearance !== "default" && `ads-link--${e.appearance}`
    ]), { iconProps: s } = m(
      r(() => e.prependIcon),
      { size: 18 }
    ), { iconProps: d } = m(
      r(() => e.appendIcon),
      { size: 18 }
    ), p = t(() => e.nuxt ? c("NuxtLink") : e.to ? c("RouterLink") : e.as), v = t(() => {
      const n = {};
      return e.disabled && (n.disabled = !0), e.href && (n.href = e.disabled ? "javascript:void(0)" : e.href), e.external && !e.disabled && (n.rel = "noopener", n.target = "_blank"), n;
    });
    return (n, g) => (o(), i(B, l({
      as: p.value,
      class: k.value
    }, v.value, { to: n.to }), {
      default: I(() => [
        a(s) ? (o(), i(f, l({
          key: 0,
          class: "ads-link__icon ads-link__icon--prepend"
        }, a(s)), null, 16)) : u("", !0),
        b("span", P, [
          y(n.$slots, "default", {}, () => [
            h(C(n.text), 1)
          ])
        ]),
        a(d) ? (o(), i(f, l({
          key: 1,
          class: "ads-link__icon ads-link__icon--append"
        }, a(d)), null, 16)) : u("", !0)
      ]),
      _: 3
    }, 16, ["as", "class", "to"]));
  }
});
export {
  V as AdsLink
};
